const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate formEnabledBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const clientInfoSource = {
    type: 'clientInfoBehavior'
  };
  const {
    entityName,
    // Form / Report / Issue
    formTypeIdentifier // pipe / dailyInspectionReport / generalIssue
  } = await evaluateSource(clientInfoSource, content, parentContentPath, transientContext, nativeFunctions);
  if (entityName === 'Report') {
    const userPermissionsSource = {
      type: 'getUserPermissionsBehavior'
    };
    const userPermissions = await evaluateSource(userPermissionsSource, content, parentContentPath, transientContext, nativeFunctions);
    const readOnly = userPermissions.includes('report_read_only');
    const isCreatorSource = {
      type: 'isCurrentUserCreatorBehavior'
    };
    const isCreator = await evaluateSource(isCreatorSource, content, parentContentPath, transientContext, nativeFunctions);
    return readOnly && !isCreator ? false : undefined;
  }
  if (entityName === 'Form') {
    const checkPermissionSource = {
      type: 'checkPermissionBehavior',
      action: 'edit',
      formTypeIdentifier
    };
    const hasPermission = await evaluateSource(checkPermissionSource, content, parentContentPath, transientContext, nativeFunctions);
    return hasPermission ? undefined : false;
  }
  return undefined;
};
module.exports = {
  evaluate
};